import { useBridgeClubAuth } from '../contexts/BridgeClubAuthContext';

/**
 * Hook to check if the current Bridge Club member has local access.
 * Local access grants access to mill store features like shopping, orders, and lockers.
 */
export const useLocalAccess = () => {
  const { member } = useBridgeClubAuth();

  return {
    hasLocalAccess: member?.local_access || false,
    accessMethod: member?.local_access_method,
    accessGrantedAt: member?.local_access_granted_at,
    isMillMember: member?.local_access || false,  // Alias for clarity
  };
};

export default useLocalAccess;
